<template>
    <li class="nav-item dropdown">
        <a class="nav-icon" href="#" @click.prevent="modal_state = true"><i class="far fa-life-ring"></i></a>

        <el-drawer :visible.sync="modal_state" :size="'450px'" :direction="'rtl'">
            <div class="p-4">
                <ul class="list-group list-group-flush pb-4">
                    <li class="list-group-item p-1 font-weight-bolder font-size-lg">Требования к используемым программам</li>
                    <li class="list-group-item p-1">Windows 10</li>
                    <li class="list-group-item p-1">Браузер Chrome последней версии (<a target="_blank" href="https://www.google.com/intl/ru/chrome/">скачать</a>)</li>
                    <li class="list-group-item p-1">В браузере должны быть отключены лишние плагины, в том числе запретить переводчику переводить текущий сайт</li>
                </ul>

                <ul class="list-group list-group-flush pb-4">
                    <li class="list-group-item p-1 font-weight-bolder font-size-lg">Отключить замораживание неиспользуемых вкладок</li>
                    <li class="list-group-item p-1">1. Ввести в адресную строку браузера <code>chrome://flags/#calculate-native-win-occlusion</code></li>
                    <li class="list-group-item p-1">2. Выберите <code>Disable</code> в пункте <code>Calculate window occlusion on Windows</code></li>
                </ul>

                <p>AnyDesk (<a target="_blank" href="https://anydesk.com/ru/downloads/windows">скачать</a>) - для доступа разработчика к вашему компьютеру, при возникновении проблем. Установить и выдать руководителю свой ID.</p>
            </div>
        </el-drawer>
    </li>

</template>

<script>
export default {
    name: "HelpCrm",
    data: () => ({
        modal_state: false,
    }),
}
</script>

<style scoped>

</style>
